<p>fab-badge works!</p>
